<template>
  <v-container>
    <v-row justify="space-around" v-if="isAdmin">
      <v-col>
        <v-row>
          <v-col>
            <v-btn
              color="#4d48f9"
              @click="routeVenueAdd()"
              style="color: white;"
            >
              YENİ MAĞAZA EKLE
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-row justify="end">
          <v-col cols="auto">
            <v-btn
              color="#4d48f9"
              style="text-transform: none !important; color: white;"
              @click="openImportModal()"
            >
              IMPORT
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn
              color="#4d48f9"
              style="text-transform: none !important; color: white;"
              @click="exportData()"
            >
              EXPORT
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <br />
    <br />
    <v-row>
      <v-col cols="4" md="4" sm="4">
        <h4>Aktiflik/Pasiflik</h4>
        <v-select
          v-model="venuePageData.filterByStatus"
          @change="filterByVenueStatus"
          :items="statusFilterItems"
          item-text="name"
          item-value="value"
          data-vv-name="select"
          required
        ></v-select>
      </v-col>
      <v-col cols="4" md="4" sm="4">
        <h4>Şehir</h4>
        <v-select
          v-model="cityId"
          :items="allCities"
          item-text="name"
          item-value="id"
          label="Seçiniz"
          data-vv-name="select"
          required
          @change="filterByVenueCity(item, $event)"
        ></v-select>
      </v-col>
      <v-col cols="4" md="4" sm="4">
        <h4>İlçe</h4>
        <v-select
          v-model="districtId"
          :items="districtList"
          item-text="name"
          item-value="id"
          :readonly="this.isAdmin == false"
          :disabled="cityId === 0"
          label="Seçiniz"
          data-vv-name="select"
          required
          @change="filterByVenueDistrict(item, $event)"
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-show="this.isAdmin">
      <v-col cols="4" md="4" sm="4">
        <h4>Anlaşma Tipi</h4>
        <v-select
          v-model="venuePageData.hasPlusPackage"
          @change="filterByPlusPackage"
          :items="PlusPackageFilterItems"
          item-text="name"
          item-value="value"
          data-vv-name="select"
          required
        ></v-select>
      </v-col>
      <v-col cols="4" md="4" sm="4">
        <h4>Firma</h4>
        <v-select
          v-model="venuePageData.companyId"
          :items="companyList"
          item-text="companyName"
          item-value="id"
          label="Seçiniz"
          data-vv-name="select"
          required
          @change="filterByCompany(item, $event)"
        ></v-select>
      </v-col>
    </v-row>
    <v-card>
      <v-card-title>
        Mağazalar
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Ara"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="allVenueList"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
          disablePagination: true,
        }"
        :items-per-page="10"
        @update:page="getPageNumber"
        @update:items-per-page="getItemPerPage"
      >
        <!-- <template v-slot:item="{ item }" v-if="!isAdmin">
            <tr v-if="workerVenueId==item.id">
            <td class="text-xs">{{ item.venueName }}</td>
            <td class="text-xs">{{ item.address }}</td>
            <td class="text-xs">
              <v-checkbox v-model="item.open" @change="venueStatusChange(item)"></v-checkbox>
            </td>
            <td class="text-xs">
              <v-icon small class="mr-2" @click="routeVenueEdit(item)">mdi-pencil</v-icon>
            </td>
          </tr>
        </template>
           <template v-slot:item="{ item }" v-else>
            <tr >
            <td class="text-xs">{{ item.venueName }}</td>
            <td class="text-xs">{{ item.address }}</td>
            <td class="text-xs">
              <v-checkbox v-model="item.open" @change="venueStatusChange(item)"></v-checkbox>
            </td>
            <td class="text-xs">
              <v-icon small class="mr-2" @click="routeVenueEdit(item)">mdi-pencil</v-icon>
            </td>
          </tr>
        </template> -->
        <template v-slot:item.isOpen="{ item }">
          <v-checkbox
            v-model="item.isOpen"
            color="#4d48f9"
            @change="venueStatusChange(item)"
            :disabled="!item.companyIsActive"
            :readonly="!isAdmin"
          ></v-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="routeVenueEdit(item)">
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="venuePageData.pageNumber"
          :color="'#4d48f9'"
          :length="pagination.pagesLength"
          @input="setPageNumber"
        ></v-pagination>
      </div>
    </v-card>
    <v-dialog v-model="importModalOpen" max-width="600px">
      <v-card>
        <v-card-title>Import Data</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="9">
              <v-file-input
                v-model="importFile"
                accept=".csv, .xlsx, .xls"
                label="Dosya seçiniz"
              ></v-file-input>
            </v-col>
          </v-row>
          <v-row justify="space-around">
            <v-col>
              <v-row>
                <v-col>
                  <v-btn
                    color="#4d48f9"
                    style="text-transform: none !important; color: white;"
                    @click="downloadSampleExcel"
                  >
                    Örnek Dosya İndir
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-row justify="end" class="mx-2">
                <v-col cols="auto">
                  <v-btn
                    color="#4d48f9"
                    style="text-transform: none !important; color: white;"
                    @click="uploadFile"
                  >
                    Yükle
                  </v-btn>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    color="#4d48f9"
                    style="text-transform: none !important; color: white;"
                    @click="closeImportModal"
                  >
                    İptal
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="importFileResponseDialog.show" max-width="600px">
      <v-card>
        <v-card-title>İmport Detay</v-card-title>
        <v-card-text>
          <p>{{ importFileResponseDialog.message }}</p>

          <v-row justify="space-around">
            <v-col>
              <v-row>
                <v-col>
                  <v-btn
                    v-if="!importFileResponseDialog.isSuccess"
                    color="#4d48f9"
                    style="text-transform: none !important; color: white;"
                    @click="
                      downloadLogFileAsync(importFileResponseDialog.logFileUrl)
                    "
                  >
                    Log Dosyasını İndir
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-row justify="end" class="mx-2">
                <v-col cols="auto">
                  <v-btn
                    color="#4d48f9"
                    style="text-transform: none !important; color: white;"
                    @click="closeImportFileResponseDialog"
                  >
                    Kapat
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Venues',
  data: () => ({
    search: '',
    workerVenueId: 0,
    cityId: 0,
    districtId: 0,
    districtList: [],
    allCities: [],
    companyList: [],
    isAdmin: false,
    statusFilterItems: [
      {
        name: 'Hepsi',
        value: null,
      },
      {
        name: 'Aktif',
        value: true,
      },
      {
        name: 'Pasif',
        value: false,
      },
    ],
    PlusPackageFilterItems: [
      {
        name: 'Hepsi',
        value: null,
      },
      {
        name: 'Basic + Plus Paket Anlaşması',
        value: true,
      },
      {
        name: 'Basic Paket Anlaşması',
        value: false,
      },
    ],
    venuePageData: {
      pageNumber: 1,
      pageSize: 10,
      search: '',
      filterByStatus: null,
      cityId: null,
      districtId: null,
      hasPlusPackage: null,
      companyId: null,
    },
    pagination: {
      totalItems: 20,
      pagesLength: 0,
    },
    headers: [
      {
        text: 'Mağaza Adı',
        value: 'venueName',
        align: 'start',
      },
      {
        text: 'Kod',
        value: 'code',
        filterable: false,
      },
      {
        text: 'Adres',
        value: 'address',
        filterable: false,
      },
      {
        text: 'Aktif/Pasif',
        value: 'isOpen',
      },
      {
        text: 'Detay',
        value: 'actions',
        sortable: false,
      },
    ],
    importModalOpen: false,
    importFile: null,
    importFileResponseDialog: {
      show: false,
      isSuccess: true,
      message: '',
      count: 0,
      logFileUrl: '',
    },
  }),

  computed: mapGetters(['allVenueList', 'loading', 'importResponse']),
  created() {
    const page = this.$route.query.page ? this.$route.query.page : 1
    this.venuePageData.pageNumber = Number(page)

    this.getVenueList(this.venuePageData).then((response) => {
      this.pagination.totalItems = response.totalCount
      this.pagination.pagesLength = response.totalPages
    })
    this.workerVenueId = localStorage.getItem('venueId')

    this.userRoles = JSON.parse(localStorage.getItem('userRoles'))

    if (
      this.userRoles.find((x) => x == 'PanelUser') != null &&
      this.userRoles.find((x) => x == 'PanelUser') != undefined
    ) {
      this.isAdmin = true
      console.log('admin', this.isAdmin)
    }
    this.getCompanieList().then((companyList) => {
      let allCompaniesOption = {
        id: 0,
        companyName: 'Tüm Firmalar',
      }
      this.companyList = [allCompaniesOption, ...companyList]
    })
    this.getCityList().then((cityList) => {
      let allCitiesOption = {
        id: 0,
        name: 'Tüm Şehirler',
      }
      this.allCities = [allCitiesOption, ...cityList]
    })
    if (this.cityId) {
      this.getDistrictList(this.venueData.cityId).then((districtList) => {
        if (!this.cityId) return

        this.districtList = districtList
      })
    }
  },
  methods: {
    ...mapActions([
      'getVenueList',
      'postUpdateActiveVenue',
      'getCityList',
      'getDistrictList',
      'importWorkingHours',
      'exportVenues',
      'getCompanieList',
      'exportVenueTemplate',
      'downloadLogFile',
    ]),
    //Data table item per page changed function
    getItemPerPage(val) {
      this.venuePageData.pageSize = val
      this.venuePageData.pageNumber = 1
      this.getVenueList(this.venuePageData).then((response) => {
        this.pagination.pagesLength = response.totalPages
      })
    },
    //Data table page number changed function
    getPageNumber(val) {
      this.venuePageData.search = this.search
      this.venuePageData.pageNumber = val
      if (val !== 1) {
        this.$router.push({
          query: {
            page: val,
          },
        })
      }
      this.getVenueList(this.venuePageData)
    },
    setPageNumber(val) {
      if (
        (!this.$route.query.page && val == 1) ||
        this.$route.query.page == val
      )
        return
      this.$router.push({
        path: this.$route.fullPath,
        query: {
          page: val,
        },
      })
    },
    getItemPerSearch(val) {
      this.venuePageData.pageNumber = 1
      this.venuePageData.search = val
      this.getVenueList(this.venuePageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },

    filterVenues() {
      this.venuePageData.pageNumber = 1
      this.getVenueListAndSetPagination()
    },
    getVenueListAndSetPagination() {
      this.getVenueList(this.venuePageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },

    filterByVenueStatus(value) {
      this.venuePageData.filterByStatus = value
      this.venuePageData.cityId = this.cityId
      this.filterVenues()
    },
    filterByPlusPackage(value) {
      this.venuePageData.hasPlusPackage = value
      this.filterVenues()
    },
    filterByCompany(item, newValue) {
      this.venuePageData.companyId = newValue
      this.filterVenues()
    },
    filterByVenueCity(item, newValue) {
      this.getDistrictList(newValue).then((districtList) => {
        this.districtList = districtList
        let allDistrictOption = {
          id: 0,
          name: 'Hepsi',
        }
        this.districtList = [allDistrictOption, ...districtList]
      })
      this.districtId = 0
      this.venuePageData.districtId = 0
      this.venuePageData.cityId = this.cityId
      this.filterVenues()
    },
    filterByVenueDistrict(item, newValue) {
      this.districtId = newValue
      this.venuePageData.districtId = newValue
      this.venuePageData.pageNumber = 1
      this.filterVenues()
    },
    //VenueStatus
    venueStatusChange(venue) {
      console.log('venueStatus', venue)
      this.postUpdateActiveVenue(venue).then((response) => {
        console.log("response", response);
        if (response.processStatus == "Success") {
          alert("Güncelleme işlemi başarılıdır");
        } else {
          alert('Bir hata oluştu')
        }
      })
    },
    //VenueAdd
    routeVenueAdd() {
      this.$router.push('venue')
    },
    //VenueEdit
    routeVenueEdit(item) {
      console.log('item', item)
      this.$router.push(`venue/${item.id}`)
    },
    openImportModal() {
      this.importModalOpen = true
    },
    closeImportModal() {
      this.importModalOpen = false
    },
    closeImportFileResponseDialog() {
      this.importFileResponseDialog.show = false
    },
    async downloadSampleExcel() {
      this.exportVenueTemplate()
    },
    async downloadLogFileAsync(url) {
      this.downloadLogFile(url)
    },
    async uploadFile() {
      if (!this.importFile) {
        this.showSnackbar('Please select a file to upload.', 'error')
        return
      }
      await this.importWorkingHours(this.importFile)
      this.importFile = null
    },
    async exportData() {
      try {
        await this.exportVenues(this.venuePageData)
      } catch (error) {
        console.error('Export error:', error)
      }
    },
    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.color = color
      this.snackbar.show = true
    },
  },
  watch: {
    search: function (val, oldVal) {
      if (val.length < 2 && oldVal.length < 2) return
      this.getItemPerSearch(val)
    },
    '$route.query.page'(val) {
      const pageNumber = val ? Number(val) : 1
      this.getPageNumber(pageNumber)
    },
    importResponse(newVal) {
      console.log('New', newVal)
      if (newVal) {
        this.closeImportModal()
        this.importFileResponseDialog.show = true
        if (newVal.success) {
          this.importFileResponseDialog.isSuccess = true
          this.importFileResponseDialog.message = 'Dosya başarıyla yüklenmiştir'
        } else {
          this.importFileResponseDialog.isSuccess = false
          this.importFileResponseDialog.message = newVal.message
          this.importFileResponseDialog.count = newVal.count
          this.importFileResponseDialog.logFileUrl = newVal.logFileUrl
        }
      }
    },
  },
}
</script>

<style>
.v-data-footer__icons-before {
  display: none;
}

.v-data-footer__icons-after {
  display: none;
}
</style>
